(ns motorsaif.web.lib.form
  (:require
   ["@shopify/draggable" :rename {Sortable sortable}]
   ["react" :as react]
   [clojure.string :as str]
   [goog.string :as gstr :refer [format]]
   [motorsaif.data-utils :as data-utils]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.shared.form :as shared-form]
   [motorsaif.url :as url]
   [motorsaif.web.lib.image-uploader :as image-uploader]
   [reagent.core :as r]
   [reagent.ratom :as ra]
   [taoensso.encore :as encore]))


;; include make form, use its own input renders hre
(comment
  ;; (.destroy sorted)
  (do
    (def media-list (first (.querySelectorAll js/document ".uploaded-media")))
    (def sorted (new sortable media-list (clj->js {:draggable ".wrapper"}) ))
    (.on sorted "sortable:start" (fn []
                                   (println "start")
                                   (map #(encore/as-int ^js (.-dataset.id %)) (.querySelectorAll media-list ".wrapper"))
                                   ))
    (.on sorted "drag:stopped" (fn []
                                 (println "stop")
                                 (map #(encore/as-int ^js (.-dataset.id %)) (.querySelectorAll media-list ".wrapper"))
                                 ))))

(defn presentable-error-msg [error]
  (when error
    (if (keyword? error)
      (tr [:malli error])
      (str error))))

(defn presentable-error [error]
  [:span.error
   (when-let [e (presentable-error-msg error)]
     [:span.val e])])

(defn- default-wrapper
  "Wraps a component with error message"
  [{:keys [path opts state error] :as args} comp]
  (fn []
    (let [?error (error path)
          state (state path)
          {:keys [class]} opts
          klass (str/join " " [(name state)
                               (conj class)])]
      [:div.input-wrap
       {:class klass}
       [comp
        (when (= state :error) [:span.error
                                ;; [:i.fa-duotone.fa-circle-exclamation]
                                [:span.val
                                 (presentable-error-msg ?error)]])]])))


(defn event->value [e]
  (let [?target (and e
                     (aget e "target"))
        val (if ?target
              (.-value ?target)
              e)
        val (if (string? val)
              (if (empty? val)
                nil
                (str/trim val))
              val)]
    val))

(defn uploaded-img [{:keys [remove-fn img] :as argz}]
  (let [uploader-record (meta img)
        {:keys [*state *progress upload-fn]} uploader-record
        {:media/keys [preview]} img]
    [:div.prog-wrap
     ;; (str ":staate" @*state)
     [:div.image-wrap
      [:button.remove-img.if-c
       {:type "button"
        :on-click #(remove-fn img)}
       [:i.fas.fa-xmark]]
      [:img {:src preview}]]
     [(fn [p]
        (let [percent (* p 100)]
          [:div.progress
           [:div.bar
            {:class
             (if (= p 1) "done" "uploading")
             :style
             {:width (format "%s%" percent)}}]])) @*progress]]))

(defn existing-img [{:keys [img remove-fn]}]
  (let [{db-id :db/id
         path :media/path} img
        src (url/uploaded-media {:media img
                                 :size :med})]
    [:div.image-wrap
     [:button.remove-img
      {:type "button"
       :on-click #(remove-fn img)}
      [:i.fas.fa-xmark]]
     [:img {:src src}]]))

(defn attach-sortable
  [parent child-selector on-sort]
  (let [sorted (new sortable parent (clj->js {:draggable child-selector
                                              :delay 130}))]

    (.on sorted "drag:start"
         (fn [e]
           (when-not (every? identity (mapv #(.-dataset.id ^js %) (.querySelectorAll parent child-selector)))
             (.cancel e))
           ))
    (.on sorted "drag:stopped" on-sort)
    #(.destroy sorted)))


;; (keys @re-frame.db/app-db)
;; (meta ahz)
;; {:db/id 17592186046765, :media/path "44-23/03f3438f223cfa9a61ca66e9fc281a991a4a5dbb.jpg", :media/order 2}


(defn- media
  "Media weaves newly uploaded and existing images.

  New uploads with their progress are stored under the form key's
  `[:uploads (media path) <uuid>]`
  and existing media and successfully uploaded media are stored in
  `[:(media path)]`

  To prevent image showing twice for a successful image, metadata is set to point to its [:uploads] key equivalent and that is rendered instead of downloading the image again.

  Media path consists of a vector containing both
    Existing image {:db/id ... :media/path ...}
    Successful image ^:uuid <uuid> {:db/id ... :media/path ...}

  So we loop through media path, if a uuid is found that source is used instead. "
  [{:keys [get-val set-val path opts] :as args}]
  (let [{:keys [after-remove]} opts
        *images (ra/reaction
                 (shared-form/combined-images
                  (get-val path)
                  (get-val [:uploads :raw])))

        ref (react/createRef)

        remove-fn (partial shared-form/remove-image (assoc args :after-remove after-remove))
        args (-> args
                 (assoc :remove-fn remove-fn))

        *sortable (atom nil)
        init-sortable-fn (fn []
                           (when @*sortable (@*sortable)) ; cleanup existing instance
                           (reset! *sortable
                                   (attach-sortable
                                    (.-current ref)
                                    ".drag-wrap"
                                    (fn []
                                      (doall (map-indexed
                                              (fn [idx itm]
                                                (let [db-id (encore/as-int ^js (.-dataset.id itm))
                                                      images (get-val path)
                                                      path-idx (data-utils/mapval-idx images :db/id db-id)]

                                                  (set-val (conj path path-idx) (fn [m]
                                                                                  (with-meta (assoc m :db/id db-id
                                                                                                    :media/order idx)
                                                                                    {:replace true})))))
                                              (.querySelectorAll (.-current ref) ".wrapper")))))))]

    (fn []
      ^{:key (str @*images)}
      [default-wrapper (-> args
                           (assoc-in [:opts :class] (format "images-%s" (count @*images))))
       (if (seq @*images)
         (fn []
           (r/create-class
             {:component-did-mount init-sortable-fn
              :component-did-update init-sortable-fn
              :reagent-render
              (fn []
                (let [can-drag? (every? :db/id @*images)
                      nodes
                      (mapv
                       (fn [img]
                         (let [{?db-id :db/id
                                ?uuid :uuid} img
                               args (assoc args
                                           :img img
                                           :remove-fn #(remove-fn img))]

                           [:div.wrapper
                            {:data-id ?db-id
                             :class (when can-drag? "drag-wrap")}
                            (if ?uuid
                              [uploaded-img args]
                              [existing-img args])]))
                       (sort-by :media/order @*images))]
                  [:div.outer-media-wrap
                   (if can-drag?
                     [:div.status-hint "Drag to rearrange"]
                     [:div.status-hint "Uploading"])

                   (into [:div.uploaded-media
                          {:ref ref}] nodes)]))}))
         (fn []))])))

(defn image-uploader
  [{:keys [file-limit error on-mount path get-val set-val] :as args}]
  (let [*input-ref (atom nil)
        file-limit (or file-limit 3)
        get-file-count #(let [uploads (get-val [:uploads :raw])
                              existing (get-val path)]
                          (count (distinct (mapcat identity
                                             [(map (fn [v]
                                                     (:db/id @(:*response v))) uploads)
                                              (map :db/id existing)]))))
        uploader-args {:img-opts {:preview {:maxWidth 320
                                            :maxHeight 320}
                                  :full {:maxWidth 1680
                                         :maxHeight 1680}}
                       :on-load
                       (fn [img-rec]
                         ;; (def jojojo img-rec)
                         ;; ;; ((:upload-fn jojojo))
                         ;; @(:*progress jojojo)
                         (set-val [:uploads :raw] (fnil conj []) img-rec)
                         ((:upload-fn img-rec)))
                       :on-success (fn [media]
                                     (set-val path (fnil
                                                    (fn [old]
                                                      (let [new-id (:db/id media)]
                                                        ;; If item has already been uploaded, do not add it again
                                                        (if (seq (filter #(= (:db/id %) new-id) old))
                                                          old
                                                          (conj old (assoc media
                                                                           :media/order (count old)))))) [])))
                       :get-file-count get-file-count
                       :file-limit file-limit}]
    (r/create-class
      {:component-did-mount #(when on-mount (on-mount %))
       :reagent-render
       (fn [{:keys [choose-comp]}]
         [default-wrapper args
          (fn [error]
            [:div.upload-wrapper
             {:on-click #(.click @*input-ref)}
             error
             [:label.file-uploader.image
              {:style {:display "none"}}
              [:input.inputfile
               {:accept "image/*"
                :ref #(reset! *input-ref %)
                :multiple true
                :name "file-upload"
                :type "file"
                :on-change #(do
                              (image-uploader/handle-files uploader-args %)
                              (set! (.-value @*input-ref) nil))}]]
             (let [at-limit? (>= (get-file-count) file-limit)]
               (or
                (and choose-comp
                     [choose-comp
                      {:type "button"
                       :disabled at-limit?}])
                [:button.btn.link
                 {:type "button"
                  :disabled at-limit?}
                 [:i.far.fa-paperclip]
                 [:span.txt
                  "Choose Images "
                  (format "%s/%s" (get-file-count) file-limit)]]))])])})))

(defn check [{:keys [default-value choices opts path get-val set-val on-change] :as args}]
  (let [name (str path)
        {:keys [class]} opts
        class (or class "default")
        default-set (set (get-val path))]
    (fn []
      [default-wrapper args
       (fn [error]
         (let [val (get-val path)]
           [:div
            {:class (str/join " " ["check-group" class])}
            error
            (for [choice choices
                  :let [{:keys [value title desc on-select]} choice
                        id (str (gensym "check"))]]
              ^{:key id}
              [:div.choice
               [:input {:id id
                        :type "checkbox"
                        :checked ((set val) value)
                        :on-change #(do
                                      (set-val path (fnil (fn [old]
                                                            (if ^js (.-target.checked %)
                                                              (conj old value)
                                                              (disj old value)))
                                                          #{}))
                                      (when on-select
                                        (on-select value)))
                        :name name}]
               [:label {:for id}
                [:span.title title]
                (when desc [:span.desc desc])]])]))])))

(defn radio [{:keys [default-value choices opts path get-val set-val on-change] :as args}]
  (let [name (str path)
        {:keys [class]} opts
        class (or class "default")]
    (fn []
      [default-wrapper args
       (fn [error]
         [:div
          {:class (str/join " " ["radio-group" class])}
          (when error error)
          (doall (for [choice choices
                 :let [{:keys [value title desc on-select]} choice
                       id (str (gensym "radio"))]]
             ^{:key value}
             [:div.choice
              [:input {:id id
                       :type "radio"
                       :default-checked (or
                                         (= value (get-val path))
                                         (= default-value value))
                       :on-change #(do
                                     (set-val path value)
                                     (when on-select
                                       (on-select value)))
                       :name name}]
              [:label {:for id}
               [:span.title title]
               (when desc [:span.desc desc])]]))])])))


;; States:

;; : NOTE should not rerender on form submit...........
(defn input [{:keys [opts path get-val on-change default-value state] :as args}]
  (let [id (str (gensym))
        -on-change on-change
        {:keys [label type placeholder helper limit on-change
                no-spaces
                rows disabled
                ref on-key-down hide-errors]} opts
        type (-> type
                 (or :text)
                 name)
        *value (r/atom default-value)
        ref (or ref (react/createRef))
        default-value (or (:default-value opts)
                          default-value
                          (get-val path))
        no-space-fn (fn [e]
                      (let [kc (.-keyCode e)]
                        (when (= kc 32) (.preventDefault e))))]
    (fn []
      [default-wrapper args
       (fn [error]
         [:div
          {:class (str "text-input-group input-" type)}
          (when-not hide-errors
            (if label
              [:label {:for id}
               [:span label]
               error]
              [:span.no-label
               error]))
          (condp = type
            "textarea"
            [:textarea.form-control
             {:id id
              :placeholder placeholder
              :ref ref
              :default-value default-value
              :disabled disabled
              :rows rows
              :on-change (fn [e]
                           (reset! *value (event->value e))
                           (-on-change e)
                           #_(when refocus (.focus (.-current ref)))
                           )}]
            [:input.form-control
             (cond-> {:type type
                      :default-value default-value
                      :placeholder placeholder
                      :disabled disabled
                      :ref ref
                      :id id
                      :on-change (fn [e]
                                   (when on-change
                                     (on-change (.-value (.-current ref))))
                                   (-on-change e))}
               no-spaces (assoc :on-key-down no-space-fn)
               )])
          (when limit
            (let [char-count (count @*value)]
              [:div.char-limit
               {:class (when (> char-count limit) "overflow")}
               (str char-count "/" limit)]))
          (when helper
            [:div.helper.muted helper])])])))

(defn debugger []
  (js/eval "debugger"))

;; (debugger)

;; https://stackoverflow.com/questions/39439115/how-to-execute-click-function-before-the-blur-function
(defn select [{:keys [choices opts on-change default-value can-add?] :as args}]
  (let [id (str (gensym))
        {:keys [label type placeholder helper data disabled after-change]} opts
        type (-> type
                 (or :text)
                 name)
        *focus (r/atom false)
        *value (r/atom nil)
        *input-ref (atom nil)
        *set-value (r/atom "")
        clear-input (fn []
                      (reset! *value "")
                      (set! (.-value @*input-ref) ""))
        after-change (fn [value]

                       (when after-change
                         (after-change value))
                       (reset! *set-value (:title (first (filter #(= (:value %) value) choices)))))
        default-value (or (:default-value opts) default-value)
        ?default-value (when default-value
                         (:title (first (filter #(= (:value %) default-value) choices))))]
    (fn []
      [default-wrapper args
       (fn []
         [:div.select
          {:on-blur #(reset! *focus false)
           :on-focus #(reset! *focus true)
           :class (if @*focus "focus" "")}
          (when label [:label {:for id} label])
          [:div.select-wrap
           [:i.fas.fa-caret-down]
           [:input.form-control
            (-> {:type type
                 :auto-complete (str "new-" id)
                 :name (str "new-" id)
                 :placeholder (or ?default-value placeholder "Choose an option")
                 :disabled disabled
                 :on-blur #(when-not (empty? @*value)
                             (on-change @*value))
                 :ref #(reset! *input-ref %)
                 ;; :class (if @*focus "focus" "")
                 :id id
                 :on-change #(reset! *value (event->value %))}
                (cond-> (not @*focus)
                  (assoc :value @*set-value)))]
           [:div.ul-wrap
            (into [:ul.select-options.style-scroll]
                  (let [filtered-items (shared-form/regex-filter-items @*value choices :title)
                        on-click (fn [value]
                                   (on-change value)
                                   (after-change value)
                                   (reset! *focus false))]
                    (cond (seq filtered-items)
                          (map (fn [{:keys [title value img]}]
                                 [:li.item
                                  {:tabIndex -1
                                   :on-click #(on-click value)}
                                  [:span.wrap
                                   (when img [:span.img [:img {:src img}]])
                                   [:span.title title]]])
                               filtered-items)
                          (and can-add? (seq @*value))
                          [[:li.item
                            {:tabIndex -1
                             :on-click #(on-click @*value)}
                            [:span.wrap
                             [:span.title (format "Add %s" @*value)]]]]
                          can-add?
                          [[:li.item
                            {:tabIndex -1
                             :on-click #(on-click @*value)}
                            [:span.wrap
                             [:span.title (format "Start typing" @*value)]]]]
                          :else
                          [[:li.item
                            {:tabIndex -1
                             :on-click #(do
                                          (clear-input)
                                          (reset! *focus false))}
                            [:span.wrap
                             [:span.title (format "%s not found" @*value)]]]])))]]
          (when helper
            [:div.helper.muted helper])])])))

(def registry
  {:input input
   :media media
   :select select
   :check check
   :radio radio
   :uploader image-uploader
   :presentable-error presentable-error})


(defn make-form
  "Returns a map that can be used to render full input or parameter helpers to be mixed into form elements
  to handle change events, set values, etc.

           [input {:style 'bootstrap'
                   :label 'Model'
                   :path [:car :car/make]}]
  State is held internally and synchronized with change-watch

  Default and init data.
  Init data is set in beginning and sent along with request.
  "
  [{:keys [change-watch init-fn init-data schema on-submit] :as args}]
  (shared-form/make-form (assoc args :render-components registry)))
